/*eslint no-unused-vars: ["error", { "varsIgnorePattern": ".*Menu|.*Index" }]*/

'use strict';

(function () {
    let mainMenu = null;
    let mobileMenu = null;
    let readMoreMenu = null;
    let searchIndex = null;
    let searchIndexData = null;

    $(function () {
        setupMenu();
        setupBackToTop();
        setupMobileNavButtons();
        setupSearch();
        setupChat();

        // Scroll to end of breadcrumbs
        var elem = $('.breadcrumbs ul');
        if (elem.length > 0) {
            elem[0].scrollLeft = elem[0].scrollWidth;
        }
    });

    function setupChat() {
        ChatBot.setup();
    }

    function setupSearch() {
        let searchIdxDl = null;
        let searchIdxDataDl = null;
        let resultTimeout = 0;
        let $resultsContainer = $('.search-results');

        function getSearchResults(txt) {
            let results = searchIndex.search(txt);
            if (results.length > 0) {
                results.forEach(r => {
                    let post = searchIndexData.get(r.ref);
                    r.url = r.ref;
                    r.title = r.ref;

                    if (post !== undefined) {
                        r.url = post.url;
                        r.title = post.title;
                    }
                });
            }
            return results;
        }

        function downloadSearchIndex(searchInput) {
            $resultsContainer.html(`<p>${window.i18n.getString('search.index_download')}</p>`);

            const lang = $('html').attr('lang');

            if (searchIndexData === null && searchIdxDataDl === null) {
                searchIdxDataDl = $.getJSON(`/${lang}/search_index_data.json`, function (data) {
                    searchIndexData = new Map();
                    for (const post of data) {
                        searchIndexData.set(post.url, post);
                    }
                    doSearch(searchInput);
                })
                    .fail(function () {
                        $resultsContainer.html("<p>Could not download search index file 'search_index_data.json'. Search not available.</p>");
                    })
                    .always(function () {
                        searchIdxDataDl = null;
                    });
            }

            if (searchIndex === null && searchIdxDl === null) {
                searchIdxDl = $.getJSON(`/${lang}/search_index.json`, function (data) {
                    searchIndex = lunr.Index.load(data);
                    doSearch(searchInput);
                })
                    .fail(function () {
                        $resultsContainer.html("<p>Could not download search index file 'search_index.json'. Search not available.</p>");
                    })
                    .always(function () {
                        searchIdxDl = null;
                    });
            }
        }

        function doSearch(searchInput) {
            if (searchIndexData === null || searchIndex === null) {
                downloadSearchIndex(searchInput);
                return;
            }

            let content = window.i18n.getString('search.help');

            let txt = $(searchInput).val();
            if (txt.length > 0) {
                let results = getSearchResults(txt);
                if (results.length > 0) {
                    content = `<p><span class="result-count">${results.length} `;
                    content += results.length == 1 ? window.i18n.getString('search.result') : window.i18n.getString('search.results');
                    content += `</span> ${window.i18n.getString('search.for')} '<b>${txt}</b>'</p><ol>`;

                    results.forEach(r => {
                        content += `<li><a href="${r.url}">${r.title}</a></li>`;
                    });

                    content += '</ol>';
                }
            }

            // Display search results
            $resultsContainer.html(content);

            // Sync search inputs
            $('.search-input').val(txt);
        }

        // Search when clicking search button
        $('#Search').on('click', function () {
            let $si = $('#DesktopSearchInput');
            doSearch($si.get(0));
            $si.get(0).focus();
        });

        // Search when clicking mobile search button
        $('#Mobile-Search').on('click', function () {
            let $si = $('#MobileSearchInput');
            doSearch($si.get(0));
            $si.get(0).focus();
        });

        // Search when pressing Enter in the search input fields
        $('.search-input').on('keyup', function (event) {
            if (event.key === 'Enter') {
                doSearch(this);
            }
        });

        // Search when input fields are updated;
        // remove if slow
        $('.search-input').on('input', function () {
            doSearch(this);
        });

        // Show results when search input in focus
        $('#DesktopSearchInput').on('focusin', function () {
            clearTimeout(resultTimeout);
            $('#DesktopSearchResults').removeClass('hide').addClass('open');
        });

        // Hide results when search input not in focus
        $('#DesktopSearchInput').on('focusout', function () {
            resultTimeout = setTimeout(function () {
                $('#DesktopSearchResults').removeClass('open').addClass('hide');
            }, 300);
        });
    }

    function setupMenu() {
        mainMenu = new NavMenu({
            activemenu_class: 'active',
            elementid: 'Navigation',
            menuid: 'MainMenu',
            menuitems_class: 'nav',
        });

        mobileMenu = new NavMenu({
            activemenu_class: 'active',
            elementid: 'Mobile-Navigation-Screen',
            menuid: 'MobileMenu',
            menuitems_class: 'nav',
        });

        readMoreMenu = new NavMenu({
            activemenu_class: 'active',
            elementid: 'ReadMore',
            menuid: 'ReadMoreMenu',
            menuitems_class: '',
        });
    }

    function setupMobileNavButtons() {
        $('#MobileNavOpen').on('click', function () {
            $('#Mobile-Popup').removeClass('show-search').addClass('show-nav').removeClass('hide').addClass('open');
        });

        $('.search-open').on('click', function () {
            $('#Mobile-Popup').removeClass('show-nav').addClass('show-search').removeClass('hide').addClass('open');
            $('#MobileSearchInput').get(0).focus();
        });

        $('#MobilePopupClose').on('click', function () {
            $('#Mobile-Popup').removeClass('open').addClass('hide');
        });
    }

    function setupBackToTop() {
        //Get the button
        var mybutton = document.getElementById('BackToTop');
        mybutton.onclick = function () {
            topFunction();
        };

        // When the user scrolls down 20px from the top of the document, show the button
        window.onscroll = function () {
            scrollFunction();
        };

        function scrollFunction() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                mybutton.style.display = 'block';
            } else {
                mybutton.style.display = 'none';
            }
        }

        // When the user clicks on the button, scroll to the top of the document
        function topFunction() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
    }
})();
